<vrm-page-container>
  <mat-progress-bar *ngIf="showProgressBar" mode="determinate" [value]="percentProgress.value" class="green-progress">
  </mat-progress-bar>

  <vrm-driver-import-grid #driverImportGrid
    [metadata]="gridMeta"
    (dataChange)="updateDriverImportPage()"
    (uploadDrivers)="openUploadDialog()"
    (editNewConfig)="openEditDialog()"
    [rawData]="data"
    [configurationDataAvailable] = 'hasConfigurations'
  >
  </vrm-driver-import-grid>
</vrm-page-container>
